export const OPEN_REPLAY_IGNORED_ERROR_METHODS: Record<string, string[]> = {
    "plan.getByPointId": ["-32500", "-32050"],
    "plan.getFullUnassignedPlanByRouteId": ["-32050"],
    "kpi.getSalaryToPay": ["-32008"],
};
